import { HIDE_LOADER, SHOW_LOADER } from "./constants";

export const showLoader = (message, timer, cancel) => async (dispatch) => {
  dispatch({ type: SHOW_LOADER, payload: { message, timer, cancel } });
};

export const hideLoader = () => async (dispatch) => {
  dispatch({ type: HIDE_LOADER });
};